// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-product-popup {
  visibility: hidden;
  position: fixed;
  display: flex;
  width: 25rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  background-color: white;
  z-index: 1;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  padding: 1rem;
  gap: 2rem;
}
.new-product-popup__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.new-product-popup__header__titles {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.new-product-popup__header__titles__title {
  font-size: 1rem;
  font-weight: bold;
  color: black;
}
.new-product-popup__header__titles__subtitle {
  font-size: 0.75rem;
  color: #7E7E7E;
}
.new-product-popup__header__close-button {
  width: 40px;
  height: 40px;
  background-color: white;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.new-product-popup__content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.new-product-popup__content__title {
  font-size: 0.9rem;
  color: black;
  font-weight: bold;
}
.new-product-popup__content .p-inputtext {
  width: 100%;
  border-radius: 7px;
}
.new-product-popup__content__clickable-text {
  display: flex;
  justify-content: end;
  font-size: 0.85rem;
  color: #4D4D4D;
  cursor: pointer;
}
.new-product-popup__footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 0.5rem;
}
.new-product-popup__footer__confirm-button {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.new-product-popup__footer__cancel-button {
  width: fit-content;
  height: 40px;
  background-color: #F5F6FA;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}

.visible {
  visibility: visible !important;
  opacity: 1;
  transition: visibility 0s, opacity 0.5s linear;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/new-product-popup/new-product-popup.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAER;AADQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAGZ;AAFY;EACI,eAAA;EACA,iBAAA;EACA,YAAA;AAIhB;AAFY;EACI,kBAAA;EACA,cAAA;AAIhB;AADQ;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGZ;AAAI;EACG,aAAA;EACA,sBAAA;EACA,YAAA;AAEP;AADO;EACK,iBAAA;EACA,YAAA;EACA,iBAAA;AAGZ;AADO;EACK,WAAA;EACA,kBAAA;AAGZ;AADO;EACC,aAAA;EACA,oBAAA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AAGZ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AAER;AADQ;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGZ;AAAQ;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAEZ;;AAEA;EACI,8BAAA;EACA,UAAA;EACA,8CAAA;AACJ;;AACA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAEJ","sourcesContent":[".new-product-popup{\n    visibility: hidden;\n    position: fixed;\n    display: flex;\n    width: 25rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    flex-direction: column;\n    background-color: white;\n    z-index: 1;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);\n    border-radius: 1rem;\n    padding: 1rem;\n    gap: 2rem;\n    &__header{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        &__titles{\n            display: flex;\n            flex-direction: column;\n            gap: 0.25rem;\n            &__title{\n                font-size: 1rem;\n                font-weight: bold;\n                color: black;\n            }\n            &__subtitle{\n                font-size: 0.75rem;\n                color: #7E7E7E;\n            }\n        }\n        &__close-button{\n            width: 40px;\n            height: 40px;\n            background-color: white;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n    }\n    &__content{\n       display: flex;\n       flex-direction: column;\n       gap: 0.75rem;\n       &__title{\n            font-size: 0.9rem;\n            color: black;\n            font-weight: bold;\n       }\n       .p-inputtext{\n            width: 100%;\n            border-radius: 7px;\n       }\n       &__clickable-text{\n        display: flex;\n        justify-content: end;\n            font-size: 0.85rem;\n            color: #4D4D4D;\n            cursor: pointer;\n       }\n    }\n    &__footer{\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        gap: 0.5rem;\n        &__confirm-button{\n            width: fit-content;\n            height: 40px;\n            background-color:#4F4BFF;\n            color: white;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n\n        &__cancel-button{\n            width: fit-content;\n            height: 40px;\n            background-color:#F5F6FA;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n    }\n}\n.visible{\n    visibility: visible !important;\n    opacity: 1;\n    transition: visibility 0s, opacity 0.5s linear;\n}\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
